import React from "react";

import { observer, inject } from "mobx-react";
import { observable, action, toJS } from "mobx";

import Icon from "sulu-admin-bundle/components/Icon";
import Table from "sulu-admin-bundle/components/Table";

import FooterStaffRow from "./rows/FooterStaffRow";
import StaffRow from "./rows/StaffRow";

const { Header, Body, HeaderCell } = Table;

const StaffListTable = inject("selectionStore")(
    observer(({ selectionStore, openModal, props }) => {
        const filteredPlayers = Object.values(selectionStore.allPlayers).filter(
            (p) => !p.isDeleted && p.dhbTeam === selectionStore.teamId,
        );

        return (
            <>
                <Table>
                    <Header>
                        <HeaderCell>
                            {!props.disabled && (
                                <Icon name="su-plus" onClick={openModal} />
                            )}
                        </HeaderCell>
                        <HeaderCell>Name</HeaderCell>
                        <HeaderCell>Funktion</HeaderCell>
                        <HeaderCell>
                            <Icon name="su-trash-alt" />
                        </HeaderCell>
                    </Header>

                    <Body>
                        {filteredPlayers.map((player, index) => {
                            return (
                                <StaffRow
                                    key={player.contact}
                                    player={player}
                                    index={index}
                                    disabled={props.disabled}
                                />
                            );
                        })}
                    </Body>
                </Table>

                <FooterStaffRow
                    noOfSelectedPlayer={filteredPlayers.length}
                    minStaff={props.data.minNominatedStaffMembers}
                    maxStaff={props.data.maxNominatedStaffMembers}
                />
            </>
        );
    }),
);

export default StaffListTable;
